import * as React from "react";
import "./ToggleSwitch.component.css";
import { useEffect, useState } from "react";
export function ToggleSwitch({ option1, option2, selected, onChange }) {
    const [current, setCurrent] = useState(selected);
    useEffect(() => {
        setCurrent(selected);
    }, [selected]);
    const handleClick = () => {
        if (current === option1) {
            setCurrent(option2);
            onChange(option2);
        }
        else {
            setCurrent(option1);
            onChange(option1);
        }
    };
    return (React.createElement("div", { className: "toggle-switch", onClick: handleClick },
        React.createElement("div", { className: `toggle-switch-option ${selected === option1 ? "toggle-switch-option-selected" : ""}` }, option1),
        React.createElement("div", { className: `toggle-switch-option ${selected === option2 ? "toggle-switch-option-selected" : ""}` }, option2)));
}
